var ConfigureViewSizeChangedArgs = /** @class */ (function () {
    function ConfigureViewSizeChangedArgs(viewType, height, width, viewId) {
        this.viewType = viewType;
        this.height = height;
        this.width = width;
        this.viewId = viewId;
    }
    return ConfigureViewSizeChangedArgs;
}());
export { ConfigureViewSizeChangedArgs };
